import React, { useEffect, useRef } from 'react';
// import { EventEmitter } from '../../events.js';
import { Col, Card, Divider, Space } from 'antd';

import { useDispatch, useSelector } from 'react-redux';
import { setTemplateInfo, setcurrent } from "../../store/cards/cards.actions";

import SavedCard from "../../components/savedCard";
    
const Preview = () => {
    const cardHTML = useRef(null);
    const dispatch = useDispatch();
    const { selected, eCards } = useSelector(state => state.cards);

    // const getLogoPos = (data) => {
    //     switch (data) {
    //         case 'left':
    //             return 'left: 0'
    //             break;
    //         case 'right':
    //             return 'right: 0'
    //             break;
    //         case 'top':
    //             return 'top: 0'
    //             break;
    //         case 'bottom':
    //             return 'bottom: 0'
    //             break;
        
    //         default:
    //             break;
    //     }
    // }

    const cardStyle = {
        parent: {
            position: 'relative',
            // width: '50%',
            display: 'flex',
            justifyContent: 'space-between',
            borderWidth: 0,
            backgroundColor: 'transparent'
        },
        head: {
            width: '100%',
            // height: '6rem',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginLeft: 'auto',
            marginRight: 'auto',
            position: 'relative'
        },
        mainImage: {
            width: '50%',
            borderRadius: '1rem',
            boxShadow: 'rgba(0, 0, 0, 0.31) 0px 0px 4px 0px',
            maxHeight: '12rem',
            minHeight: '12rem',
            objectFit: 'cover'
            // boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
        },
        absoluteSec: {
            position: 'absolute',
            width: '50%',
            height: '100%'
        },
        logoImg: {
            width: '2.5rem',
            marginLeft: 'auto',
            marginRight: 'auto'
        }
    };

    let classStyles = {
        position: 'absolute',
        padding: '1rem',
        [selected.logo_position[0]]: 0,
    };

    if (selected.logo_position[1] === 'center') {
        classStyles.width = '100%'
    } else {
        classStyles[selected.logo_position[1]] = 0
    }

    const goBackNEdit = () => {
        dispatch(setcurrent(3))
    };

    const handleEditTemplate = (val) => {
        dispatch(setcurrent(val))
    };    

    useEffect(() => {
        console.log('cardHTML', cardHTML.current.innerHTML)
        dispatch(setTemplateInfo('card_style', cardHTML.current.innerHTML));
    }, [dispatch]);

    // <Screenshot
    //     image={selected.logo}
    //     width="100"
    //     height="100"
    //     onSave={() => {}}
    //     onCancel={() => {}}
    //     onOk={() => {}}
    // />      

    return (
        <>
            <Col span={16} className="pt-4">
                <Card className="rounded-large shadow-lg">
                    <h2 className="text-xl font-bold text-center text-primary">Preview & Save</h2>
                    <div ref={cardHTML}>
                        <div style={cardStyle.parent}>
                            <div style={cardStyle.head}>
                                <img 
                                    id="tempId" 
                                    src={selected.image} 
                                    style={cardStyle.mainImage} 
                                    alt="" 
                                />

                                <div style={cardStyle.absoluteSec}>
                                    {selected.show_amount &&
                                        <div 
                                            style={{
                                                color: `${selected.default_color}`,
                                                font_weight: `${selected.font_weight}`,
                                                fontSize: '1.0rem',
                                                position: 'absolute',
                                                top: 0,
                                                right: 0,
                                                padding: '1.0rem'
                                            }}>
                                                ¢{selected.amount}
                                        </div>
                                    }

                                    {!selected.type &&
                                        <div className={`${selected.logo_position[0]}-0 ${selected?.logo_position[1]?.includes("flex--basic", "center") ? 'inset-y-0 flex--basic' : `${selected.logo_position[1]}-0`}`}
                                            style={classStyles}
                                        >
                                            {selected.logo?                                  
                                                <img src={selected.logo} style={cardStyle.logoImg} alt="" />
                                            :
                                                <div
                                                    style={{
                                                        color: `${selected.default_color}`, 
                                                        borderColor: `${selected.default_color}`,
                                                        width: '6rem',
                                                        height: '2.5rem',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        borderStyle: 'dashed',
                                                        borderWidth: '1px'
                                                    }}
                                                >
                                                    Logo
                                                </div>
                                            }
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                    <Divider className="border-black" />    

                    <div className="w-full text-base">
                        <div>
                            <h1 className="font-bold text-lg text-center">
                                {selected.category}
                            </h1>
                        </div>

                        <div className="flex--between">
                            <Space direction="vertical" className="w-1/3">
                                <div className="font-bold text-base">Card Title</div>
                                <div className="text-sm">{selected.title || 'N/A'}</div>
                            </Space>

                            <div className="rounded-full p-2 hover:bg-gray-200 cursor-pointer">
                                <img src={require("../../assets/images/edit.svg")}
                                    className="w-6"
                                    onClick={() => { dispatch(setcurrent(2)) }}
                                    alt=""
                                />
                            </div>
                        </div>

                        <div className="flex mt-4">
                            <Space direction="vertical" className="w-1/2">
                                <div className="font-bold text-base">Amount</div>
                                <div className="text-sm">GH¢ {selected.amount || 'N/A'}</div>
                            </Space>
                            <Space direction="vertical" className="w-1/2">
                                <div className="font-bold text-base capitalize">Promotion?</div>
                                <div className="text-sm">{selected.is_promotion ? 'YES' : 'NO' || 'N/A'}</div>
                            </Space>                            
                        </div>

                        {selected.is_promotion &&
                            <div className="flex mt-4">
                                <Space direction="vertical" className="w-1/2">
                                    <div className="font-bold text-base capitalize">What type of promotion</div>
                                    <div className="text-sm capitalize">{selected.promo_type || 'N/A'}</div>
                                </Space>
                                <Space direction="vertical" className="w-1/2">
                                    <div className="font-bold text-base capitalize">Promo Value</div>
                                    <div className="text-sm">{selected.promo_value || 'N/A'}</div>
                                </Space>
                            </div>
                        }

                        {selected.promo_state === "closed" &&
                            <div className="flex mt-4">
                                <Space direction="vertical" className="w-1/2">
                                    <div className="font-bold text-base">Start Date</div>
                                    <div className="text-sm">{selected.promotion_start || 'N/A'}</div>
                                </Space>
                                <Space direction="vertical" className="w-1/2">
                                    <div className="font-bold text-base">End Date</div>
                                    <div className="text-sm">{selected.expiry_date || 'N/A'}</div>
                                </Space>                            
                            </div>
                        }
                    </div>

                    <Divider className="border-black" />

                    <div className="">
                        <Space direction="vertical" className="w-full">
                            <div className="font-bold text-base">Description</div>
                            <div className="w-full">{selected.description || 'N/A'}</div>
                        </Space>        
                    </div>

                    <Divider className="border-black" />

                    <div className="">
                        <Space direction="vertical" className="w-full">
                            <div className="font-bold text-base">Terms and Conditions</div>
                            <div className="w-full">{selected.promotion_terms || 'N/A'}</div>
                        </Space>        
                    </div>                    
                </Card>
            </Col>
            <Col span={8} className="pt-4 pl-4">
                <Card
                    title="Drafted e-gift cards"
                    extra={<span className="font-bold text-xl">{eCards.length}</span>}
                    className="saved--cards rounded-large shadow-lg p-2 text-primary"
                    style={{minHeight: '50vh'}}
                    bodyStyle={{padding: '1rem'}}
                    // size="small"
                >
                    {eCards.length <= 0 ?
                        <div className="flex--basic pt-10">
                            <div>
                                <svg className="fill-current mx-auto w-20 h-20" width="64" height="64" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clipath="url(#clip0)">
                                <path d="M510.244 143.201C508.039 138.251 504.041 134.463 498.984 132.536L288.653 52.3913C280.875 49.4256 272.363 51.5884 266.889 57.1949L262.089 30.1713C260.146 19.2352 249.632 11.9039 238.654 13.8227L93.7357 39.1885C89.656 39.9024 86.9272 43.7891 87.6412 47.8687C88.3551 51.9474 92.2408 54.6741 96.3214 53.9632L241.239 28.5974C244.044 28.1095 246.83 30.0293 247.321 32.7941L255.904 81.1128L235.014 135.135L225.584 81.3958C224.246 72.7725 215.854 65.7952 207.191 67.464L64.7162 92.7708C56.2129 94.2827 50.6044 102.972 52.2143 112.141L97.1903 368.439C98.5382 377.064 106.899 384.034 115.584 382.37L141.166 377.827L136.104 390.919C133.207 398.133 135.084 406.854 140.592 412.313L82.4586 422.488C79.6509 422.976 76.8681 421.056 76.3762 418.291L15.1146 73.4125C14.5746 70.6987 16.6314 67.848 19.3632 67.434L60.3256 60.2636C64.4062 59.5497 67.134 55.663 66.4201 51.5834C65.7061 47.5038 61.8134 44.779 57.7398 45.4889L16.7784 52.6593C6.06235 54.3002 -1.77196 65.4002 0.346851 76.0353L61.6085 420.913C63.5003 431.913 74.3234 439.218 85.0434 437.262L164.449 423.363L358.092 497.148C368.223 501.092 380.219 496.017 384.214 485.563L486.635 220.705C488.129 216.842 486.208 212.499 482.345 211.005C478.482 209.512 474.139 211.432 472.646 215.295L370.225 480.154C369.208 482.784 366.1 484.153 363.434 483.132L153.101 402.987C150.503 402.064 149.043 398.881 150.093 396.327L159.67 371.56C159.927 371.067 160.129 370.546 160.272 370.003L204.086 256.701C205.58 252.839 203.659 248.496 199.796 247.002C195.933 245.509 191.591 247.43 190.097 251.292L147.492 361.468L113.038 367.588C112.765 367.481 112.147 366.895 111.963 365.846L66.987 109.548C66.8 108.486 67.191 107.718 67.416 107.525L209.736 82.2467C210.009 82.3537 210.627 82.9397 210.811 83.9886L224.54 162.223L203.243 217.297C201.749 221.159 203.67 225.502 207.533 226.996C211.296 228.481 215.741 226.607 217.232 222.706L269.816 86.7233C270.561 85.6914 271.043 84.4725 271.189 83.1736L276.521 69.3858C277.538 66.7551 280.647 65.3892 283.312 66.4071L493.644 146.553C496.243 147.477 497.703 150.658 496.654 153.212L485.793 181.299C484.299 185.162 486.22 189.504 490.083 190.998C493.944 192.487 498.288 190.571 499.782 186.709L510.643 158.622C512.581 153.608 512.44 148.133 510.244 143.201V143.201Z" fill="#A2A2B5"/>
                                <path d="M390.227 220.701C372.303 212.413 355.098 216.503 345.131 220.461C341.072 211.408 332.465 198.053 315.503 191.512C310.327 189.516 292.028 183.742 273.844 193.241V193.242C254.581 203.302 249.107 223.389 246.768 231.968C232.394 284.698 287.834 339.093 294.203 345.122C295.597 346.442 297.443 347.176 299.358 347.176C299.411 347.176 299.464 347.175 299.517 347.174C314.493 346.858 390.333 342.826 412.722 294.48C415.97 287.467 424.597 268.837 417.174 248.922C410.768 231.735 396.196 223.46 390.227 220.701V220.701ZM399.113 288.177C381.578 326.04 318.572 331.335 302.299 332.071C291.121 320.927 250.147 276.605 261.24 235.911C263.218 228.657 267.331 213.563 280.788 206.535C293.72 199.783 307.48 204.493 310.107 205.507C327.962 212.391 333.107 230.601 333.636 232.654C334.716 237.37 340.598 239.812 344.699 237.252C346.753 236.045 365.306 225.704 383.933 234.315C388.217 236.294 398.66 242.194 403.12 254.16C408.358 268.213 402.113 281.695 399.113 288.177V288.177Z" fill="#A2A2B5"/>
                                </g>
                                <defs>
                                <clipPath id="clip0">
                                <rect width="512" height="512" fill="white"/>
                                </clipPath>
                                </defs>
                                </svg>
                                <div className="font-bold">
                                    No Cards Available
                                </div>
                            </div>
                        </div>
                    :
                        <div className="w-full">
                            {eCards.map((card, index) => (
                                <div className="flex flex-col" key={index}>
                                    <SavedCard 
                                        card={card} 
                                        setcurrent={handleEditTemplate}
                                    />
                                    <Divider className="border-black" />
                                </div>
                            ))}
                        </div>                    
                    }
                </Card>
            </Col>
        </>        
    )
};

export default Preview;